import { render, staticRenderFns } from "./OrganizationDescription.vue?vue&type=template&id=731ce3d6&scoped=true&"
import script from "./OrganizationDescription.vue?vue&type=script&lang=js&"
export * from "./OrganizationDescription.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "731ce3d6",
  null
  
)

export default component.exports